import React from 'react';
import { LucideIcon } from 'lucide-react';

interface SectionHeaderProps {
    icon: LucideIcon;
    title: string;
    description?: string;
    className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ icon: Icon, title, description, className = "" }) => (
    <div className={`flex items-center gap-3 md:gap-4 mb-5 md:mb-8 ${className}`}>
        <div className="p-2 md:p-3 rounded-xl md:rounded-2xl bg-primary-500/10 text-primary-400 border border-primary-500/20 shadow-lg shadow-primary-950/20 shrink-0">
            <Icon size={20} className="md:w-6 md:h-6" />
        </div>
        <div>
            <h2 className="text-lg md:text-2xl font-bold text-white tracking-tight font-sans">
                {title}
            </h2>
            {description && (
                <p className="text-primary-200/50 text-[11px] md:text-sm mt-1 font-light italic leading-tight">
                    {description}
                </p>
            )}
        </div>
    </div>
);

export default SectionHeader;
